<template>
  <div class="d-flex align-items-center justify-content-center flex-wrap">  

    <!-- Skeleton -->
    <div class="d-flex align-items-center" style="min-height: 111px;" v-if="menus.length == 0">
        <steps-bookings-skeleton v-for="(item, index) in countAdministrador" :key="index" :linea=" index == 6 ? false : true"/>
    </div>
    <!-- Steps bookings -->
    <div v-else v-for="(item, index) in menus" :key="index">
      <step-point-component
        :text="item.nombre"
        :counter="item.cantidad"
        :first="index == 0 && true"
        :active="index == 0 && true"
        :last="index == menus.length - 1 && true"
        :icon="item.icon"
        :size="17"
        :width="60"
        :url="item.url"
        :color="(isAdmin || user.id_role == 9999) ? '#0c67c9' : '#dc3545'"
        scale
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { getContadorBooking } from "../../constants/dashboard";

import StepsBookingsSkeleton from './skeletons/stepsBookingsSkeleton';


// Componente Step Point
import StepPointComponent from "./StepPointComponent";

export default {
  props: ["rol"],
  data() {
    return {
      menus: [],
      bookingContadoresClientesAux: "",
      dataAux: [],
      countAdministrador : 7,
      user:{
        id_role: 0
      }
    };
  },

  computed: {
    ...mapState("lineas", [
      "bookingContadoresClientes",
      "bookingContadoresUCC",
      "contadorMenuBookings"
    ]),

    ...mapState(["isAdmin"]),
  },

  components: { StepPointComponent, StepsBookingsSkeleton },

  methods: {
    ...mapActions("lineas", [
      "actionSetBookingContadoresClientes",
      "actionSetBookingContadoresUCC",
    ]),

    setMenuDependiendoRol() {
      switch (this.user.id_role) {

        // Administrador
        case 1:
          this.menus = [
            {
              id : "cont_bookings_declarados",
              nombre: "Bookings declarados",
              icon: "fas fa-inbox",
              url: "bookings_declarados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_declarados
                : 0
            },
            {
              id : "cont_bookings_solicitados",
              nombre: "Bookings solicitados",
              icon: "fas fa-hourglass-end",
              url: "bookings_solicitados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_solicitados
                : 0,
            },
            {
              id : "cont_bookings_confirmados",
              nombre: "Bookings confirmados",
              icon: "fas fa-check",
              url: "bookings_confirmados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_confirmados
                : 0,
            },
            {
              id : "cont_solicitudes_confirmacion",
              nombre: "Solicitudes de modificación",
              icon: "fas fa-undo",
              url: "solicitudes_modificacion",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_solicitudes_confirmacion
                : 0,
            },
            {
              id : "cont_bookings_embarcados",
              nombre: "Bookings embarcados",
              icon: "fas fa-ship",
              url: "bookings_embarcados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_embarcados
                : 0,
            },
            {
              id : "cont_bookings_cancelados",
              nombre: "Bookings cancelados",
              icon: "fas fa-calendar-times",
              url: "bookings_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_cancelados
                : 0,
            },
            {
              id : "cont_bookings_declarados_cancelados",
              nombre: "Bookings declarados cancelados",
              icon: "fas fa-times",
              url: "ver_Bookings_declarados_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_bookings_declarados_cancelados
                : 0,
            },
          ];
          break;

        // Ejecutivo
        case 2 :
           this.menus = [
            {
              id : "cont_bookings_declarados",
              nombre: "Bookings declarados",
              icon: "fas fa-inbox",
              url: "bookings_declarados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_declarados
                : 0
            },
            {
              id : "cont_bookings_solicitados",
              nombre: "Bookings solicitados",
              icon: "fas fa-hourglass-end",
              url: "bookings_solicitados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_solicitados
                : 0,
            },
            {
              id : "cont_bookings_confirmados",
              nombre: "Bookings confirmados",
              icon: "fas fa-check",
              url: "bookings_confirmados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_confirmados
                : 0,
            },
            {
              id : "cont_solicitudes_confirmacion",
              nombre: "Solicitudes de modificación",
              icon: "fas fa-undo",
              url: "solicitudes_modificacion",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_solicitudes_confirmacion
                : 0,
            },
            {
              id : "cont_bookings_embarcados",
              nombre: "Bookings embarcados",
              icon: "fas fa-ship",
              url: "bookings_embarcados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_embarcados
                : 0,
            },
            {
              id : "cont_bookings_cancelados",
              nombre: "Bookings cancelados",
              icon: "fas fa-calendar-times",
              url: "bookings_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_cancelados
                : 0,
            },
            {
              id : "cont_bookings_declarados_cancelados",
              nombre: "Bookings declarados cancelados",
              icon: "fas fa-times",
              url: "ver_Bookings_declarados_cancelados",
              cantidad: this.bookingContadoresClientesAux ? this.bookingContadoresClientesAux.cont_bookings_declarados_cancelados : 0,
            },
          ];
          break;

        // Cliente
        case 3 :
          this.menus = [
            {
              id : "cont_bookings_por_aceptar",
              nombre: "Mis Bookings por aceptar",
              icon: "fas fa-tasks",
              url: "ver_bookings_por_aceptar",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_por_aceptar
                : 0,
            },
            {
              id : "cont_bookings_por_confirmar",
              nombre: "Bookings por confirmar",
              icon: "fas fa-pause",
              url: "bookings_por_confirmar",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_por_confirmar
                : 0,
            },
            {
              id : "cont_bookings_confirmados",
              nombre: "Bookings confirmados",
              icon: "fas fa-check",
              url: "bookings_confirmados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_confirmados
                : 0,
            },
            {
              id : "cont_solicitudes_modificacion",
              nombre: "Solicitudes de modificación",
              icon: "fas fa-undo",
              url: "solicitudes_modificacion",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_solicitudes_modificacion
                : 0,
            },
            {
              id : "cont_bookings_embarcados",
              nombre: "Bookings embarcados",
              icon: "fas fa-ship",
              url: "bookings_embarcados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_embarcados
                : 0,
            },
            {
              id : "cont_bookings_cancelados",
              nombre: "Bookings cancelados",
              icon: "fas fa-calendar-times",
              url: "bookings_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_cancelados
                : 0,
            },
            {
              id : "cont_bookings_declarados_cancelados",
              nombre: "Bookings declarados cancelados",
              icon: "fas fa-times",
              url: "ver_Bookings_declarados_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_bookings_declarados_cancelados
                : 0,
            },
          ];
          break;
        
        // Embarcador
        case 4:
          this.menus = [
            {
              id : "cont_bookings_solicitados",
              nombre: "Bookings solicitados",
              icon: "fas fa-hourglass-end",
              url: "bookings_solicitados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_solicitados
                : 0,
            },
            {
              id : "cont_bookings_confirmados",
              nombre: "Bookings confirmados",
              icon: "fas fa-check",
              url: "bookings_confirmados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_confirmados
                : 0,
            },
            {
              id : "cont_bookings_embarcados",
              nombre: "Bookings embarcados",
              icon: "fas fa-ship",
              url: "bookings_embarcados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_embarcados
                : 0,
            },
            {
              id : "cont_bookings_cancelados",
              nombre: "Bookings cancelados",
              icon: "fas fa-calendar-times",
              url: "bookings_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_cancelados
                : 0,
            },
          ];
          break;

        // Operador
        case 5:
        this.menus = [
            {
              id : "cont_bookings_declarados",
              nombre: "Bookings declarados",
              icon: "fas fa-inbox",
              url: "bookings_declarados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_declarados
                : 0
            },
            {
              id : "cont_bookings_solicitados",
              nombre: "Bookings solicitados",
              icon: "fas fa-hourglass-end",
              url: "bookings_solicitados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_solicitados
                : 0,
            },
            {
              id : "cont_bookings_confirmados",
              nombre: "Bookings confirmados",
              icon: "fas fa-check",
              url: "bookings_confirmados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_confirmados
                : 0,
            },
            {
              id : "cont_solicitudes_confirmacion",
              nombre: "Solicitudes de modificación",
              icon: "fas fa-undo",
              url: "solicitudes_modificacion",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_solicitudes_confirmacion
                : 0,
            },
            {
              id : "cont_bookings_embarcados",
              nombre: "Bookings embarcados",
              icon: "fas fa-ship",
              url: "bookings_embarcados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_embarcados
                : 0,
            },
            {
              id : "cont_bookings_cancelados",
              nombre: "Bookings cancelados",
              icon: "fas fa-calendar-times",
              url: "bookings_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_cancelados
                : 0,
            },
            {
              id : "cont_bookings_declarados_cancelados",
              nombre: "Bookings declarados cancelados",
              icon: "fas fa-times",
              url: "ver_Bookings_declarados_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_bookings_declarados_cancelados
                : 0,
            },
          ];
          break;
        
        // Super Administrador
        case 9999:
          this.menus = [
            {
              id : "cont_bookings_declarados",
              nombre: "Bookings declarados",
              icon: "fas fa-inbox",
              url: "bookings_declarados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_declarados
                : 0
            },
            {
              id : "cont_bookings_solicitados",
              nombre: "Bookings solicitados",
              icon: "fas fa-hourglass-end",
              url: "bookings_solicitados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_solicitados
                : 0,
            },
            {
              id : "cont_bookings_confirmados",
              nombre: "Bookings confirmados",
              icon: "fas fa-check",
              url: "bookings_confirmados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_confirmados
                : 0,
            },
            {
              id : "cont_solicitudes_confirmacion",
              nombre: "Solicitudes de modificación",
              icon: "fas fa-undo",
              url: "solicitudes_modificacion",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_solicitudes_confirmacion
                : 0,
            },
            {
              id : "cont_bookings_embarcados",
              nombre: "Bookings embarcados",
              icon: "fas fa-ship",
              url: "bookings_embarcados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_embarcados
                : 0,
            },
            {
              id : "cont_bookings_cancelados",
              nombre: "Bookings cancelados",
              icon: "fas fa-calendar-times",
              url: "bookings_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux.cont_bookings_cancelados
                : 0,
            },
            {
              id : "cont_bookings_declarados_cancelados",
              nombre: "Bookings declarados cancelados",
              icon: "fas fa-times",
              url: "ver_Bookings_declarados_cancelados",
              cantidad: this.bookingContadoresClientesAux
                ? this.bookingContadoresClientesAux
                    .cont_bookings_declarados_cancelados
                : 0,
            },
          ];
          break;
        
         // Naviera
        case 10000:
          break;

        default:
          break;
      }
    },

    async recargarDataContadores() {
      let data = await getContadorBooking();

      this.bookingContadoresClientesAux = data[0];

      setTimeout(() => {
        this.setMenuDependiendoRol();
      }, 700);
    },

    async recargarDataContadoresLoop() {
      let data = await getContadorBooking();
      this.bookingContadoresClientesAux = data[0];

      setTimeout(() => {
        this.setMenuDependiendoRol();
      }, 700);
    },
  },
  created() {

    this.recargarDataContadores();

    this.user = JSON.parse(localStorage.getItem("user"));
  },

  watch : {
    contadorMenuBookings : function(_new){

      if(_new){

        switch (this.user.id_role) {
          case 1:

            this.menus[0].cantidad = _new.cont_bookings_declarados;
            this.menus[1].cantidad = _new.cont_bookings_solicitados;
            this.menus[2].cantidad = _new.cont_bookings_confirmados;
            this.menus[3].cantidad = _new.cont_solicitudes_confirmacion;
            this.menus[4].cantidad = _new.cont_bookings_embarcados;
            this.menus[5].cantidad = _new.cont_bookings_cancelados;
            this.menus[6].cantidad = _new.cont_bookings_declarados_cancelados;
            
          break;

          case 3 : 

            this.menus[0].cantidad = _new.cont_bookings_por_aceptar;
            this.menus[1].cantidad = _new.cont_bookings_por_confirmar;
            this.menus[2].cantidad = _new.cont_bookings_confirmados;
            this.menus[3].cantidad = _new.cont_solicitudes_modificacion;
            this.menus[4].cantidad = _new.cont_bookings_embarcados;
            this.menus[5].cantidad = _new.cont_bookings_cancelados;
            this.menus[6].cantidad = _new.cont_bookings_declarados_cancelados;

          break;
          case 5 : 

          this.menus[0].cantidad = _new.cont_bookings_declarados;
            this.menus[1].cantidad = _new.cont_bookings_solicitados;
            this.menus[2].cantidad = _new.cont_bookings_confirmados;
            this.menus[3].cantidad = _new.cont_solicitudes_confirmacion;
            this.menus[4].cantidad = _new.cont_bookings_embarcados;
            this.menus[5].cantidad = _new.cont_bookings_cancelados;
            this.menus[6].cantidad = _new.cont_bookings_declarados_cancelados;

          break;

          case 9999:

            this.menus[0].cantidad = _new.cont_bookings_declarados;
            this.menus[1].cantidad = _new.cont_bookings_solicitados;
            this.menus[2].cantidad = _new.cont_bookings_confirmados;
            this.menus[3].cantidad = _new.cont_solicitudes_confirmacion;
            this.menus[4].cantidad = _new.cont_bookings_embarcados;
            this.menus[5].cantidad = _new.cont_bookings_cancelados;
            this.menus[6].cantidad = _new.cont_bookings_declarados_cancelados;

          break;
        
          default:
            break;
        }

      }

    }
  }
};
</script>